import { Dropdown } from "primereact/dropdown";

const FilterComponentDropdown = (props) => {
  const { field, options, onChangeFilterValue, onEnter, value } = props;

  const handleChange = (e) => {
    const selected = e.value;
    onChangeFilterValue({
      field,
      operator: "equals",
      value: [selected],
    });
  };

  return (
    <Dropdown
      value={value}
      onKeyDown={onEnter}
      onChange={handleChange}
      options={options}
      optionLabel="name"
      optionValue="value"
      placeholder="Select..."
      className="w-full"
    />
  );
};

export default FilterComponentDropdown;
